import React from 'react';
import { LeadFormData } from '../leadFormUtils';

const FOLLOW_UP_FIELDS: {
  key: keyof LeadFormData;
  label: string;
  placeholder?: string;
}[] = [
  { key: 'remarks1stTime', label: 'Remarks 1st Time (Date)', placeholder: 'Called on 15/02' },
  { key: 'secondCallDate', label: '2nd call date', placeholder: 'Follow up scheduled' },
  { key: 'thirdCallDate', label: 'On 3rd call (Date)' },
  { key: 'biodataReceived', label: 'Bio-data Received or Not (Date)' },
  { key: 'profileCreated', label: 'Profile Created or Not (Date)' },
  { key: 'membership', label: 'Membership (Free|Paid) Date', placeholder: 'Free trial started' },
  {
    key: 'amountProfilesShared',
    label: 'Amount and How many profile to be share (Date)',
  },
  { key: 'shared', label: 'Shared (Date)' },
  { key: 'left', label: 'Left' },
  { key: 'retainerFormSent', label: 'Retainer form sent or not (date)' },
  { key: 'retainerSigned', label: 'Retainer Signed or not by client (date)' },
  { key: 'anyOtherRemark', label: 'Any other Remark (date)' },
];

export interface LeadFollowUpSectionProps {
  formData: LeadFormData;
  onFieldChange: <K extends keyof LeadFormData>(field: K, value: LeadFormData[K]) => void;
}

export const LeadFollowUpSection: React.FC<LeadFollowUpSectionProps> = ({
  formData,
  onFieldChange,
}) => (
  <section className="lead-form-shared__section">
    <h3 className="lead-form-shared__section-title">Follow-up &amp; remarks</h3>
    <p className="lead-form-shared__section-subtitle">
      Free-text fields matching the client sheet (dates often stored as DD/MM/YYYY).
    </p>

    <div className="lead-form-modal__row">
      {FOLLOW_UP_FIELDS.map(({ key, label, placeholder }) => (
        <div key={key} className="lead-form-modal__field">
          <label className="lead-form-modal__label" htmlFor={`lead-${key}`}>
            {label}
          </label>
          <input
            id={`lead-${key}`}
            type="text"
            className="lead-form-modal__input lead-form-modal__input--plain"
            placeholder={placeholder}
            value={formData[key]}
            onChange={(e) => onFieldChange(key, e.target.value)}
          />
        </div>
      ))}
    </div>
  </section>
);
